import i18next from 'i18next';
import trFile from '../resources/tr-TR.json';
import enFile from '../resources/en-US.json';
import arFile from '../resources/ar-SA.json';

import { Log } from 'ng2-logger';

const L = Log.create('Translator');


let _instance: Translator;
export default class Translator {
    public static create(): Translator {
        return new Translator();
    }
    public i18n: any = {};
    public i18next: any;
    public t: any = {};

    constructor() {
        if (_instance) {
            return _instance;
        } else {
            this.init();
            _instance = this;
        }
    }

    public init = (): void => {
        const options = {
            resources: {
                en: {
                    translation: enFile
                },
                tr: {
                    translation: trFile
                },
                ar: {
                    translation: arFile
                }
            },
            lng: 'tr',
            interpolation: {
                escapeValue: false
            }
        };

        const onInit = (err: any, t: any) => {
            if (!err) {
                this.i18n.t = t;
                this.t = t;
            }
        };
        this.i18next = i18next;
        this.t = i18next.t;
        this.i18n = i18next.init(options, onInit);
    }

    public setLanguage = (lang: string) => {
       if (lang === 'ar')
        {
            document.body.setAttribute('dir', 'rtl')
        }
        else
        {
            document.body.setAttribute('dir', 'ltr')
        }

        this.i18next.changeLanguage(lang);
    }
}
